import PropTypes from 'prop-types';
import React from 'react';
import BreadcrumbsBackLink from './breadcrumbsBackLink';
import Icon from '../containers/icon';
const BreadcrumbsBack = ({
  tiers: _tiers = [],
  backLabel: _backLabel = 'Filters',
  onSelect,
  onBack
}) => {
  let breadCrumbs = null;
  const tierNum = _tiers.length;
  const clearStyle = {
    clear: 'both'
  };
  const headerStyle = {
    marginBottom: '5px'
  };
  const backString = tierNum > 1 ? 'Back' : _backLabel;
  const crumbs = [];
  for (let i = 0; i < _tiers.length; i += 1) {
    const tier = _tiers[i];
    const separator = i > 0 ? ' / ' : '';
    const key = `crumb_${i}`;
    crumbs.push(/*#__PURE__*/React.createElement("small", {
      key: key
    }, " ", separator, /*#__PURE__*/React.createElement(BreadcrumbsBackLink, {
      tier: tier,
      onClick: onSelect
    })));
  }
  breadCrumbs = /*#__PURE__*/React.createElement("div", null, crumbs);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: headerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "float-md-left fade-in t-bcb-back ",
    onClick: onBack,
    onKeyPress: onBack,
    role: "link",
    tabIndex: 0,
    style: {
      outline: 'none',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "angle-left"
  }), ' ', backString), /*#__PURE__*/React.createElement("div", {
    style: clearStyle
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '3px'
    },
    className: "clear fade-in"
  }, breadCrumbs)));
};
BreadcrumbsBack.propTypes = {
  /* this property instructs the entity to
   *  use parent options a selectors of all
   *  children instead of options themselves
   */
  backLabel: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  tiers: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string
  })),
  onBack: PropTypes.func.isRequired
};
export default BreadcrumbsBack;